import React, {useState, useEffect} from 'react';

// OWN
import ToolbarFile from "../../toolbars/ToolbarFile"

// MUI V5
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';


export default function JSONSettingsToolbar(props) {
  let {
    headerRow,
    setHeaderRow,
  } = props;

  const theme = useTheme();
  const largeScreen = useMediaQuery(theme.breakpoints.up('md'));


  return (
    <MuiAppBar 
        style={{
            position: "-webkit-sticky",
            position: "sticky", // eslint-disable-line
            top: largeScreen ? theme.spacing(8) : theme.spacing(7),
            marginTop: "-78px"
        }} 
        elevation={0} 
        sx={{background: "transparent"}}
    >    
        <Toolbar variant="dense">
            {/* <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
                test
            </Typography> */}
            <div style={{flexGrow: 1}}></div>
            <ToolbarFile /> 
        </Toolbar>
    </MuiAppBar>
  );
}